const FullRow = (props) => {
    const { children } = props;
    return <div className="col-span-6">{children}</div>;
};

export default FullRow;
